import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { NetworkId } from 'data/networkId/networkId.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import ActionMenus from 'components/ActionMenus';
import NetworkIdListGridActionMenu from '../NetworkIdListGridActionMenu';

interface Props {
  data: NetworkId[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedNetworkId: NetworkId;
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onDeleteRow: () => void
}

const NetworkIdListGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedNetworkId,
  onSelectItemMenuAction,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onDeleteRow,
}: Props) => {

  const { t } = useTranslation();

  return (
    <div className="grid-container" data-testid="NetworkIdList">
      <CommonGrid
        createNewText={t('dialedDigitExtractionServer.grid.newNetworkId')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        lastUpdatedAt={lastUpdatedAt}
        onActionMenuItemClick={onSelectItemMenuAction}
        onDeleteRow={onDeleteRow}
      >
        <ActionMenus
          name={selectedNetworkId?.networkId}
          deleteTitle={t('network.deletePopup.title')}
          deleteMessage={t('network.deletePopup.message', { networkId: selectedNetworkId?.networkId })}
          hasPrivilegesToCreate={false}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={() => {}}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default NetworkIdListGrid;
